// src/components/admin/topnavbar/TopNavbar.jsx
import React, { useState, useRef, useEffect, useContext } from 'react';
import { 
  FiMenu, FiSearch, FiChevronDown, FiUser, FiX 
} from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import AppContext from '../../../context/AppContext';
import axios from 'axios';
import '../../../assets/css/equipmentrentaladmin/amintopnavbar/AdminTopNavbar.css';

const AdminTopNavbar = ({ onToggleSidebar, isSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { baseUrl, loggedInRentalAdmin } = useContext(AppContext);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);

  // Get page title
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/dashboard')) return 'Dashboard';
    if (path.includes('/myequipment')) return 'My Equipment';
    if (path.includes('/rentals')) return 'Rentals';
    if (path.includes('/maintenance')) return 'Maintenance';
    if (path.includes('/reviews')) return 'Reviews & Ratings';
    if (path.includes('/earnings')) return 'Earnings';
    if (path.includes('/messages')) return 'Messages';
    if (path.includes('/dispute')) return 'Dispute';
    if (path.includes('/ notifications')) return 'Notifications';
    if (path.includes('/support')) return 'Support';
    if (path.includes('/settings')) return 'Settings';
    return 'Dashboard';
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDropdownToggle = () => setIsDropdownOpen(!isDropdownOpen);

  const handleProfile = () => {
    navigate('/rental-admin/profile');
    setIsDropdownOpen(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/rental-admin/search?q=${searchQuery}`);
    }
  };

  return (
    <nav className="rental-admin-topnavbar">
      <div className="rental-topnavbar-left">
        {/* Hamburger Menu */}
        <button 
          className="rental-hamburger-btn" 
          onClick={onToggleSidebar}
          aria-label="rental-Toggle Sidebar"
        >
          {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        {/* Page Title */}
        <h1 className="rental-page-title">{getPageTitle()}</h1>
      </div>

      <div className="rental-topnavbar-right">
        {/* Search Bar */}
        <form className="rental-search-container" onSubmit={handleSearch}>
          <FiSearch className="rental-search-icon" />
          <input
            type="text"
            className="rental-search-input"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>

        {/* Admin Profile Dropdown */}
        <div className="rental-admin-profile-container" ref={dropdownRef}>
          <button 
            className="rental-admin-profile-btn" 
            onClick={handleDropdownToggle}
            aria-label="Admin Menu"
          >
            <div className="rental-admin-avatar">R</div>
            <span className="rental-admin-name">Rental Admin</span>
            <FiChevronDown 
              className={`chevron-icon ${isDropdownOpen ? 'rotate' : ''}`} 
              size={18} 
            />
          </button>

          {/* Dropdown Menu */}
          {isDropdownOpen && (
            <div className="rental-admin-dropdown">
              <div className="rental-dropdown-header">
                <div className="rental-dropdown-avatar">R</div>
                <div className="rental-dropdown-info">
                  <h4 className="rental-dropdown-name">Rental Admin Panel</h4>
                  <p className="rental-dropdown-email">rentaladmin@agrirent.com</p>
                </div>
              </div>
              
              <div className="rental-dropdown-divider"></div>
              
              <button className="rental-dropdown-item" onClick={handleProfile}>
                <FiUser size={18} />
                <span>Profile</span>
              </button>
              
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AdminTopNavbar;